import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';

interface CancelSubscriptionButtonProps {
  cancellationRequested?: boolean;
  onCancelSubscription?: () => void;
  size?: string;
}

const CancelSubscriptionButton = ({
  cancellationRequested,
  onCancelSubscription,
  size = 'md',
}: CancelSubscriptionButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const onConfirmCancel = () => {
    onClose();
    onCancelSubscription?.();
  };

  return (
    <>
      <Button
        colorScheme={cancellationRequested ? 'gray' : 'red'}
        variant="outline"
        data-test="listing-cancel-btn"
        isDisabled={cancellationRequested}
        onClick={onOpen}
        size={size}
      >
        {cancellationRequested ? 'Subscription Cancelled' : 'Cancel Subscription'}
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Cancel Subscription
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure? The subscription will remain active until the end of the billing cycle.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                No, Go back
              </Button>
              <Button colorScheme="red" onClick={onConfirmCancel} ml={3}>
                Yes, Cancel Subscription
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default CancelSubscriptionButton;
